import fdaServices from '../../../../../services/notisphere/fda'
import moment from 'moment'
import recallsFeedServices from '../../../../../services/notisphere/recalls-feed'

export default {
    data() {
        return {
            loadingInitial: true,
            header: [
                {
                    label: 'File Name',
                    name: 'fileName',
                    sort: false,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall table-text-ellipsis',
                },
                {
                    label: 'Status',
                    name: 'status',
                    sort: false,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: 'Uploaded At',
                    name: 'createdAt',
                    sort: false,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall table-text-ellipsis',
                },
            ],
            total: 0,
            tableData: [],
        }
    },
    methods: {
        forceRerender() {
            this.loadingInitial = true
            this.$refs.modal.show()
            this.fetchFileStatus()
            this.loadingInitial = false
        },
        onClose() {
            this.$refs.modal.hide()
        },
        fetchFileStatus() {
            recallsFeedServices.getUploadedRecallFilesStatus().then(res => {
                this.tableData = res.data.d.data.map(item => ({
                    fileName: item.fileName,
                    status: item.status,
                    createdAt: moment(item.createdAt).format('MM/DD/YYYY, HH:mm')
                })) || []
            })
        },
    },
}
